// extracted by mini-css-extract-plugin
export var alertIcon = "_ou-0";